<template>
  <div class="driverTaskDetail">
    <el-drawer size="70%" title="付款明细" :data="visible" :visible.sync="visible" :before-close="cancelModal">
      <basic-container>
        <el-descriptions>
          <el-descriptions-item label="交易类型">支付</el-descriptions-item>
          <el-descriptions-item label="收款人姓名">{{form.payeeName}}</el-descriptions-item>
          <el-descriptions-item label="手机号码">{{form.payeeMobile}}</el-descriptions-item>
          <el-descriptions-item label="收款卡号">{{form.bindingBankNo}}</el-descriptions-item>
          <el-descriptions-item label="收款银行">{{form.bindingBankName}}</el-descriptions-item>
          <el-descriptions-item label="收款金额(合计金额)">{{form.amount}}元</el-descriptions-item>
          <el-descriptions-item label="未付金额">{{form.bankNoPayAmount}}元</el-descriptions-item>
          <el-descriptions-item label="未付运单数">{{form.notWaybillCnt}}单</el-descriptions-item>
        </el-descriptions>
        <el-collapse v-if="tableData&&tableData.length>0">
          <el-collapse-item v-for="(item,index) in tableData" :key="index">
            <template slot="title">
              <div class="remark">
                第{{tableData.length-index}}次付款：已选运单数：{{item.length}}单，已选运单金额：{{totalCount(item)}}元,{{item[0].stt==40?'银行处理中！':item[0].stt==20?'付款成功！': '付款失败'}}
                <el-button
                      icon="el-icon-view"
                      size="mini"
                      type="primary"
                      :loading="btnLoading"
                      style="margin-left:20px"
                       v-if="item[0].stt==20"
                      @click.stop="voucher(item[0])">
                    凭证</el-button>
                <el-button
                      icon="el-icon-view"
                      size="mini"
                      :loading="btnLoading"
                      type="primary"
                      style="margin-left:20px"
                       v-if="item[0].stt==40"
                      @click.stop="dealSearch(item[0].companyPaymentId,item[0].batchNo)">
                    交易查询</el-button>
              </div>
            </template>
              <my-crud ref="paymentCrud" class="myCrud" :data="item" @selection-change="handleSelectionChange" :table-loading="tableLoading" :option="tableOption" >
              </my-crud>
          </el-collapse-item>
        </el-collapse>
      </basic-container>
    </el-drawer>
    <avue-sign ref="sign"></avue-sign>
     <!-- 批量打印凭证 -->
     <voucher v-if="detailVisible" :detailList="detailList" :paymentIdList="paymentIdList" :visible.sync="detailVisible"></voucher>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {getPaymentPayeeInfo,getTransStatus4047ByPaymentId,getEvidenceWhere} from '@/api/chain/companyauthrecharge'
import voucher from '../voucher.vue';

export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false
    },
    id: { //支付id
      type: String,
      default: ()=>{
        return ''
      }
    },
    payeeId: { //承运人id
      type: String,
      default: ()=>{
        return ''
      }
    },
    planId: { //资金支付计划id
      type: String,
      default: ()=>{
        return ''
      }
    },
  },
  components: {
    voucher
  },
  data() {
    return {
      form: {},
      tableData: [],
      tableLoading: false,
      tableOption: {
        dialogDrag: false,
        border: true,
        index:true,
        indexLabel: "序号",
        stripe: false,
        align: "center",
        searchShow: false,
        labelWidth: 150,
        excelBtn: true,
        printBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu:false,
        refreshBtn:false,
        useVirtual:true,
        height:"auto",
        calcHeight:310,
        columnBtn:false,
        column: [
          {
            label: "运单号",
            prop: "no",
            overHidden:true,
          },
          {
            label: "项目名称",
            prop: "projectName",
            overHidden:true,
          },
          {
            label: "出场签单土质",
            prop: "goSoilType",
            overHidden:true,
          },
          {
            label: "运输类型",
            prop: "tpModeCn",
            overHidden:true,
          },
          {
            label: "车牌号",
            prop: "truckCode",
            overHidden:true,
          },
          {
            label: "结算价",
            prop: "amount",
            overHidden:true,
          },
        ],
      },
      multipleSelection:[],
      start:1,
      end:1,
      detailVisible:false,
      detailList:[],
      paymentIdList:[],
      btnLoading:false,
    }
  },
  created() {
  },
  mounted() {
    this.getPage()
  },
  computed: {
    ...mapGetters(['permissions']),
     //已选运单金额
     settleAmtTotal() {
      return this.multipleSelection
        .map((row) => (row.settleAmt))
        .reduce((acc, cur) => parseFloat(cur) + acc, 0).toFixed(2)
    },
  },
  methods: {
    cancelModal() {
      this.$emit("update:visible", false);
      this.$emit("refreshChange");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getPage() {
      this.tableLoading = true
      getPaymentPayeeInfo({paymentId:this.id,payeeId:this.payeeId,planId:this.planId}).then(response => {
        this.form = response.data.data
        let arr = response.data.data.paymentPayeeWaybillInfoList||[]
        if(arr&&arr.length>0){
          this.tableData = [[]];
          let batchNo = arr[0].batchNo ||''
          arr.forEach(item=>{
            if(batchNo==item.batchNo){
              this.tableData[this.tableData.length-1].push(item)
            }else{
              this.tableData.push([])
              this.tableData[this.tableData.length-1].push(item)
              batchNo=item.batchNo
            }
          })
          console.log(this.tableData);
        }else{
          this.tableData = []
        }

        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    voucher(row){
      console.log(row);
      let param = {
        paymentIdList:[row.companyPaymentId],
        payeeId:row.payeeId,
        thirdVoucher:row.thirdVoucher,
        batchNo:row.batchNo,
        planId:this.planId
      }
      this.paymentIdList = [row.companyPaymentId]
      this.$refs.sign.clear()
      this.btnLoading = true
      getEvidenceWhere(param).then(res=>{
          this.btnLoading = false
          this.detailList = res.data.data
          this.detailVisible=true
          setTimeout(()=>{
          this.detailList.forEach((item,index) => {
            this.$refs.sign.getStar('支付',item.companyName,item.companyNo)
            this.$set(item,'img',this.$refs.sign.submit(80, 50))
            this.$refs.sign.clear()
          });
        },100)
      }).catch(()=>{
        this.btnLoading = false
      })
    },
    totalCount(arr){
      return arr.map((row) => (row.amount)).reduce((acc, cur) => parseFloat(cur) + acc, 0).toFixed(2)
    },
    dealSearch(paymentId,batchNo){
      this.btnLoading = true
      getTransStatus4047ByPaymentId({paymentId,batchNo}).then(res=>{
        console.log(res);
        this.btnLoading = false
        this.$message.success('查询成功')
        this.getPage();
      }).catch(()=>{
        this.btnLoading = false
      })
    },
  },
  destroyed() {
    this.$refs.sign&&this.$refs.sign.clear()
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 10px;
}
.remark{
  padding-top: 10px;
  color: red;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lists{
  border:1px solid #9a9a9a;
  padding: 10px 0px;
  .title{
    padding-left: 8px;
    text-align: left;
    height: 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #111528;
    // border-left: 4px solid #4688f7;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom:1px solid #9a9a9a;
    span{
      display: inline-block;
      height: 16px;
      width: 4px;
      background-color: #4688f7;
      margin-right: 4px;
    }
    }
  ul{
    padding: 0px 30px;
    li{
      line-height: 30px;
      color: #303133;
    }
  }
}
/deep/ .el-dialog__wrapper .el-dialog .el-dialog__body{
  padding-top: 20px;
  .voucher{
    padding-top: 20px;
    padding-bottom: 30px;
    padding-right: 60px;
  }
}
/deep/ .el-collapse .el-collapse-item__wrap{
  border-bottom: none;
  .el-collapse-item__content{
   padding-bottom: 0;
 }
}
</style>
